export default "assets/images/contact-phone-15453e29.png";